"use client";
const u = {
  js: ".js",
  db: "DB",
  sql: "SQL"
};
function i(e) {
  return Object.entries(u).reduce((t, [n, r]) => {
    const s = new RegExp(`([a-zA-Z0-9])${n}(?!\\w)`, "g");
    return t.replace(s, (a, c) => c + r);
  }, e);
}
export {
  i as standardizeSuffixes,
  u as suffixMap
};
